// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { TextSummarizerComponent } from '../text-summarizer/text-summarizer.component';
// interfaces
import { II18n } from '@app/shared/interfaces/i18n.interface';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

export interface ICardProperty {
  name: string;
  value: string | II18n | number;
  summarizeLength?: number;
  isI18nValueType?: boolean;
  icon: string;
  iconIsSvg?: boolean;
  propertyValueIcon?: string;
  valueClasses?: string;
  iconClasses?: string;
  valueIconClasses?: string;
  propertyWidth?: string;
}

@Component({
  selector: 'pwj-card-property',
  standalone: true,
  imports: [
    NgOptimizedImage,
    CommonModule,
    TextSummarizerComponent,
    TranslateModule,
    TranslateDataPipe,
  ],
  templateUrl: './card-property.component.html',
  styleUrl: './card-property.component.scss',
})
export class CardPropertyComponent {
  // inputs
  cardPropertyData = input.required<ICardProperty>();
}
